<!--
 * @Author: Lemon C
 * @Date: 2024-04-22 10:43:10
 * @LastEditTime: 2024-12-23 11:38:59
-->
<template>
    <div class="sup-bady">
        <div class="banner-box">
            <img class="banner-img" src="../../assets/imgs/contact/banner.png" alt="" />
            <span class="banner-title">联系我们</span>
        </div>
        <div class="contact-box">
            <span class="c-title">联系我们</span>
            <div class="c-line"></div>
            <div class="c-info-box">
                <div class="c-i-left-box">
                    <el-form ref="ref_elform_infoBox" :model="contact_info" :rules="contact_rules">
                        <el-form-item prop="name">
                            <el-input v-model="contact_info.name" placeholder="请输入姓名" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="organization">
                            <el-input v-model="contact_info.organization" placeholder="请输入单位" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="phone">
                            <el-input v-model="contact_info.phone" placeholder="请输入电话" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="email">
                            <el-input v-model="contact_info.email" placeholder="请输入邮箱" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="remark">
                            <el-input class="imput-height-184" v-model="contact_info.remark" placeholder="请输入备注"
                                type="textarea"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="c-i-right-box">
                    <div class="c-i-r-grid-item">
                        <div><img class="img-address" src="@/assets/imgs/contact/icon_address.png"></div>
                        <span class="c-i-r-grid-item-tip">地址</span>
                        <span class="c-i-r-grid-item-dis">上海市闵行区兴迪商务大厦1503</span>
                        <span class="c-i-r-grid-item-dis">郑州市管城回族区鑫泰大厦1310</span>
                    </div>
                    <div class="c-i-r-grid-item">
                        <div><img class="img-time" src="@/assets/imgs/contact/icon_time.png"></div>
                        <span class="c-i-r-grid-item-tip">工作时间</span>
                        <span class="c-i-r-grid-item-dis">周一至周五：7:00——19:00</span>
                        <span class="c-i-r-grid-item-dis">周末：10:00——17:00</span>
                    </div>
                    <div class="c-i-r-grid-item">
                        <div><img class="img-email" src="@/assets/imgs/contact/icon_email.png"></div>
                        <span class="c-i-r-grid-item-tip">邮箱</span>
                        <span class="c-i-r-grid-item-dis">BJ123@company.com</span>
                        <span class="c-i-r-grid-item-dis">BJ456@company.com</span>
                    </div>
                    <div class="c-i-r-grid-item">
                        <div><img class="img-phone" src="@/assets/imgs/contact/icon_phone.png"></div>
                        <span class="c-i-r-grid-item-tip">电话号码</span>
                        <span class="c-i-r-grid-item-dis">12345678910</span>
                        <span class="c-i-r-grid-item-dis">12345678911</span>
                    </div>
                </div>
            </div>
            <el-button type="primary" @click="submit_click">提交</el-button>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, getCurrentInstance } from 'vue'
import { contactUs } from '@/service/interface';

const { proxy } = getCurrentInstance();

const ref_elform_infoBox = ref(null);
const contact_info = ref({
    name: '',
    organization: '',
    phone: '',
    email: '',
    remark: '',
})

const contact_rules = ref({
    name: [
        { required: true, message: '请输入姓名', trigger: 'blur' },
        { min: 1, max: 20, message: '最长20个中文字符', trigger: 'blur' },
    ],
    organization: [
        { required: true, message: '请输入单位', trigger: 'blur' },
        { min: 1, max: 50, message: '最长50个中文字符', trigger: 'blur' },
    ],
    phone: [
        { required: true, message: '请输入电话', trigger: 'blur' },
        { pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
    ],
    email: [
        { required: false, message: '请输入邮箱地址', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
    ],
    remark: [
        { required: false, message: '备注（最多500字符）', trigger: 'blur' },
    ],
})


// MARK Click 提交
const submit_click = () => {
    ref_elform_infoBox.value.validate();

    if (contact_info.value.name === '') {
        proxy.$message.warning("请输入姓名");
        return;
    }
    if (contact_info.value.organization === '') {
        proxy.$message.warning("请输入单位");
        return;
    }
    if (contact_info.value.phone === '') {
        proxy.$message.warning("请输入联系方式");
        return;
    }
    proxy.$showLoading();
    let params = {
        name: contact_info.value.name,
        organization: contact_info.value.organization,
        phone: contact_info.value.phone,
        email: contact_info.value.email,
        remark: contact_info.value.remark,
    };
    contactUs(params).then(res => {
        proxy.$hideLoading();
        if (res.isSuccess) {
            proxy.$message.success("提交成功，专职人员即刻将与您联系！");
        }
    });
}
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-bady {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;

    .banner-box {
        position: relative;
        width: 100%;
        height: 60vh;
        margin-bottom: 50px;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .banner-img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0.8;
        }

        .banner-title {
            position: relative;
            margin-top: 80px;
            margin-left: 265px;
            font-size: 56px;
            color: var(--color-main-text-dark-bg-primary);
            line-height: 94px;
        }
    }

    .contact-box {
        position: relative;
        margin-top: 50px;
        width: 100%;
        padding: 0 270px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        .c-title {
            position: relative;
            font-weight: 400;
            font-size: 48px;
            color: var(--color-main-text-dark-bg-primary);
            line-height: 71px;
        }

        .c-line {
            position: relative;
            margin-top: 32px;
            width: 88px;
            height: 4px;
            background: var(--color-main-brand);
            border-radius: 1px;
        }

        .c-info-box {
            position: relative;
            margin-top: 87px;
            width: 100%;
            display: flex;

            :deep(.c-i-left-box) {
                position: relative;
                display: flex;
                flex-direction: column;
                width: 45%;

                .el-form {
                    position: relative;
                    display: flex;
                    flex: 1;
                    flex-direction: column;

                    .el-form-item {
                        margin-bottom: 20px !important;

                        .el-form-item__content {
                            .el-input {
                                height: 52px;

                                .el-input__wrapper {
                                    padding: 1px 30px;
                                    background-color: var(--color-main-bg-transparent) !important;

                                    .el-input__inner {
                                        font-weight: 400;
                                        font-size: 16px;
                                        color: var(--color-main-text-dark-bg-primary) !important;
                                        line-height: 24px;
                                    }
                                }
                            }

                            .imput-height-184 {
                                height: 184px;

                                .el-textarea__inner {
                                    padding: 15px 30px;
                                    background-color: var(--color-main-bg-transparent) !important;
                                    min-height: 100% !important;
                                    max-height: 100% !important;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: var(--color-main-text-dark-bg-primary) !important;
                                    line-height: 24px;
                                }
                            }
                        }
                    }
                }
            }

            .c-i-right-box {
                position: relative;
                margin-left: 170px;
                flex: 1;
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                column-gap: 70px;
                row-gap: 16px;

                .c-i-r-grid-item {
                    position: relative;
                    height: 220px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    overflow: hidden;

                    div {
                        position: relative;
                        width: 100%;
                        height: 80px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .img-address {
                            width: 53px;
                            height: 69px;
                        }

                        .img-time {
                            width: 56px;
                            height: 56px;
                        }

                        .img-email {
                            width: 62px;
                            height: 45px;
                        }

                        .img-phone {
                            width: 63px;
                            height: 57px;
                        }
                    }

                    .c-i-r-grid-item-tip {
                        position: relative;
                        margin-top: 25px;
                        margin-bottom: 27PX;
                        font-weight: 500;
                        font-size: 20px;
                        color: var(--color-main-text-dark-bg-primary);
                        line-height: 29px;
                    }

                    .c-i-r-grid-item-dis {
                        position: relative;
                        margin-bottom: 12PX;
                        font-weight: 400;
                        font-size: 16px;
                        color: var(--color-main-text-dark-bg-primary);
                        line-height: 24px;
                    }
                }
            }
        }

        .el-button {
            position: relative;
            margin-top: 32px;
            width: 132px;
            height: 38px;
            background: var(--color-main-brand);
            border-radius: 2px;
            font-size: var(--font-elbtn-title-size20);
        }
    }
}
</style>